const featureItems = [
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新',
    desc: '编辑团队每日精选最新国产电影推荐，让你永远走在观影前沿，告别片荒困扰。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '精准筛选',
    desc: '按类型、评分、热度多维度筛选，快速定位你喜欢的国产好片，省时又省心。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '客观推荐',
    desc: '综合专业影评和观众口碑，提供真实可靠的中国电影推荐，拒绝水军刷分。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配',
    desc: '桌面端与移动端完美适配，在任何设备上都能流畅浏览国产91电影推荐内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            为什么选择91电影？这里有几个理由
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-colors"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-heading font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}